import ArticleOverviewPage from "./ArticleOverviewPage"

const DashboardPage = () => {

  return (
    <>
        <ArticleOverviewPage/>
    </>
  )
}

export default DashboardPage